"use client";

import { Box, Typography } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import GppGoodIcon from "@mui/icons-material/GppGood";

function USPItem({
  title,
  description,
  icon,
}: {
  title: string;
  description: string[];
  icon: React.ReactNode;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        gap: 2,
        alignItems: "center",
        color: "white",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        padding: theme.spacing(2, 4),
        borderRadius: 20,
      })}
    >
      {icon}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6">{title}</Typography>
        {description.map((line, index) => (
          <Typography variant="body2" key={index}>
            {line}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

export default function SellLandingUSPs() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        sx={{ textAlign: "center", color: "white" }}
      >
        Why sell on Horsezone?
      </Typography>
      <Box
        sx={(theme) => ({
          display: "flex",
          gap: 8,
          padding: 2,
          justifyContent: "center",
          [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          },
        })}
      >
        <USPItem
          title="Proudly #1 since 2010"
          description={["Australia's largest equine community."]}
          icon={<EmojiEventsIcon sx={{ fontSize: "50px" }} />}
        />
        <USPItem
          title="Sell safer & faster"
          description={["Deal with trusted, genuine buyers."]}
          icon={<GppGoodIcon sx={{ fontSize: "50px" }} />}
        />
        <USPItem
          title="Listed until sold"
          description={["One fair, flat fee. No more to pay."]}
          icon={<AllInclusiveIcon sx={{ fontSize: "50px" }} />}
        />
      </Box>
    </Box>
  );
}
